var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupeeCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V7.25H2V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.75V15C2 16.1046 2.89543 17 4 17H10.5764C10.5261 16.674 10.5 16.3401 10.5 16C10.5 12.4101 13.4101 9.5 17 9.5C19.0104 9.5 20.8077 10.4127 22 11.8464V8.75H2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21C14.2386 21 12 18.7614 12 16C12 13.2386 14.2386 11 17 11C19.7614 11 22 13.2386 22 16C22 18.7614 19.7614 21 17 21ZM14.5 12.75C14.0858 12.75 13.75 13.0858 13.75 13.5C13.75 13.9142 14.0858 14.25 14.5 14.25H15.9286C16.4027 14.25 16.7948 14.4537 17.0409 14.75H14.5C14.0858 14.75 13.75 15.0858 13.75 15.5C13.75 15.9142 14.0858 16.25 14.5 16.25H17.0409C16.7948 16.5463 16.4027 16.75 15.9286 16.75C15.6205 16.75 15.3438 16.9384 15.2308 17.225C15.1179 17.5116 15.1916 17.8381 15.4168 18.0483L17.5597 20.0483C17.8625 20.3309 18.3371 20.3146 18.6197 20.0117C18.9023 19.7089 18.886 19.2343 18.5832 18.9517L17.4129 17.8595C18.0326 17.5076 18.5103 16.9402 18.714 16.25H19.5C19.9142 16.25 20.25 15.9142 20.25 15.5C20.25 15.0858 19.9142 14.75 19.5 14.75H18.714C18.6623 14.5749 18.593 14.4078 18.5083 14.25H19.5C19.9142 14.25 20.25 13.9142 20.25 13.5C20.25 13.0858 19.9142 12.75 19.5 12.75H14.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeeCard);
export default __webpack_public_path__ + "static/media/rupee-card.e6517647bf142b95a1239f83c3414384.svg";
export { ForwardRef as ReactComponent };